import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

interface IPublicDomainPresenter {
  isAllowedPublicContent: boolean;
  isShowSkeleton: boolean;
}

export function usePublicDomainPresenter(): IPublicDomainPresenter {
  const presenter = useLocalStore<IPublicDomainPresenter>(() => ({
    get isAllowedPublicContent(): boolean {
      const { isAuthenticated, isGuestCallSession } = Entities.authStore;
      return !isAuthenticated || isGuestCallSession;
    },

    get isShowSkeleton(): boolean {
      return !Entities.authStore.isFirstAuthDone;
    },
  }));

  return presenter;
}
